/**
 * Portuguese translations.
 */
export default {
  ACTION: {
    CAMPAIGNS: 'Campanhas',
    CERTIFICATES: 'Certificados',
    CHALLENGES: 'Desafios',
    CHAT: 'Chat',
    CLOSE: 'Fechar',
    CLUB: 'Club',
    COMMISSIONED_PRODUCTS: 'Produtos comissionados',
    COMMUNICATIONS: 'Comunicações',
    CONFIRM: 'Confirmar',
    COUNTERPART: 'Contrapartidas',
    DASHBOARD: 'Painel de controlo',
    DESIGN_REQUESTS: 'Design',
    DETAILS: 'Informação geral',
    EXTERNAL_APPLICATIONS: 'Aplicações externas',
    FOLLOWER_MESSAGES: 'Mensagens Seguidores',
    GENERICS: 'Genéricas',
    LINKS: 'Links',
    LIVE: 'Diretos',
    LOGOUT: 'Sair',
    MEMBERS: 'Sócios',
    MENTIONS: 'Menções',
    OFFERS: 'Ofertas',
    ON_DEMAND_CAMPAIGNS: 'Campanhas on demand',
    OPPORTUNITIES: 'Oportunidades',
    ORDERS: 'Encomendas pagas',
    PARTNERS: 'Parceiros',
    PERSONAL_AREA: 'Área pessoal',
    PRODUCTS_OFFERED: 'Produtos oferecidos',
    PROFILE: 'Perfil',
    PROZIS_COMMUNITY: 'Comunidade Prozis',
    QUESTIONS: 'Questões',
    REMUNERATIONS: 'Remunerações',
    SELECT_LANGUAGE: 'Selecionar idioma',
    SELECT_PARTNER: 'Selecione outro parceiro',
    SERVICES: 'Serviços',
    SOCIAL_NETWORK: 'Rede social Prozis',
    STATISTICS: 'Estatísticas',
    VIDEO_TUTORIALS: 'Vídeos tutoriais'
  },
  ERROR: {
    ERROR: 'Erro',
    FETCH_DATA: 'Obter dados'
  },
  HEADER: {},
  LABEL: {
    CAMPAIGNS: 'Campanhas',
    CHALLENGES: 'Desafios',
    CHAT: 'Chat',
    COMMUNICATIONS: 'Comunicações',
    COUNTERPARTS: 'Contrapartidas',
    DASHBOARD: 'Painel de controlo',
    DESIGN_REQUESTS: 'Design',
    DETAILS: 'Detalhes',
    EXTERNAL_APPLICATIONS: 'Aplicações externas',
    FILTER: 'Filtrar',
    FILTERED: 'Filtrada',
    FOLLOWER_MESSAGES: 'Mensagens Seguidores',
    GENERICS: 'Genéricas',
    HOME: 'Voltar',
    LINKS: 'Links',
    LOGOUT: 'Sair',
    MEMBERS: 'Sócios',
    MENTIONS: 'Menções do instagram',
    NOT_FOUND: '404, Estás perdido ???',
    OFFERS: 'Ofertas',
    ORDERS: 'Encomendas',
    PARTNERSHIP_NOT_FOUND: 'Não foi encontrado nenhum parceiro.',
    PENDING_COUNTERPART: 'Contrapartidas pendentes periodo anterior',
    PENDING_COUNTERPART_CURRENT: 'Contrapartidas pendentes do mês corrente',
    PENDING_REMUNERATION: 'Remunerações pendentes periodo anterior',
    PENDING_REMUNERATION_CURRENT: 'Remunerações pendentes do mês corrente',
    PERSONAL_AREA: 'Área pessoal',
    PRODUCTS: 'Produtos',
    REMUNERATIONS: 'Remunerações',
    SEARCH_PARTNERSHIP: 'Procurar um parceiro',
    SELECT_LANGUAGE: 'Selecionar idioma',
    SELECT_PARTNERSHIP: 'Selecione um parceiro',
    UNAUTHROZIED: '403, Acesso não autorizado!!!'
  },
  SENTENCE: {},
  SUCCESS: {},
  TOOLTIP: {}
};
